export interface Point {
    x: number;
    y: number;
}

export function toString(point: Point): string {
    return `(${point.x},${point.y})`;
}

export interface IPosition {
    address: string;
    coordinates: Point;
}

export interface CLocation extends IPosition {
    node_id: number;
    name: string;
    description: string | null;
}

export interface ILocation extends IPosition {
    location_id: number;
    node_id: number | null;
    name: string;
    description: string | null;
}
